import React from "react";

export function AvatarLabel({ children }: { children: React.ReactNode }) {
  return <div className="text-base font-bold text-foreground">{children}</div>;
}
